import { useTranslation } from "react-i18next";
import { SmartStoreLink } from "@/components/landing/AppStoreBadges";
import { focusRing } from "./styles";
import logo from "@/assets/logo-dark.webp";

/**
 * Fixed install bar for phones (hidden from md up). The page adds bottom
 * padding so it never covers the footer. z-40 keeps the cookie banner (z-50) on top.
 */
const MobileInstallBar = () => {
  const { t } = useTranslation();
  return (
    <div
      role="region"
      aria-label={t("home.mobileBar.label")}
      className="fixed inset-x-3 bottom-3 z-40 flex items-center justify-between gap-3 rounded-[22px] border border-foreground/10 bg-white/95 py-2 pe-2 ps-3.5 shadow-[0_18px_40px_-18px_hsl(var(--foreground)/0.45)] backdrop-blur-xl backdrop-saturate-150 md:hidden"
    >
      <span className="flex min-w-0 items-center gap-2.5">
        <img src={logo} alt="" width={90} height={125} decoding="async" className="block h-[26px] w-auto" />
        <span className="truncate text-[15px] font-semibold tracking-[-0.01em] text-foreground">
          {t("home.mobileBar.title")}
        </span>
      </span>
      <SmartStoreLink
        location="mobile_bar"
        utmCampaign="home_clarity"
        className={`inline-flex h-11 flex-none items-center rounded-full bg-foreground px-[18px] text-[15px] font-semibold text-white ${focusRing}`}
      >
        {(store) => (store === "google_play" ? t("home.mobileBar.ctaAndroid") : t("header.getApp"))}
      </SmartStoreLink>
    </div>
  );
};

export default MobileInstallBar;
